import React from 'react';
import './PopupComponent.css';
import userIcon from '../../assets/images/friend-request.png'

const PopupComponent = ({ isModalOpen, inmateKioskInvite, onSignupClick, onLoginClick }) => {
  if (!isModalOpen) return null;

  return (
    <div
      id="mdlInviteRedirectionPopup"
      className="d-flex justify-content-center align-items-center popup-overlay"
    >
      <div className="popup-container">
        <div className="popup-header">
          <div className="icon-container">
            <img
              src={userIcon}
              alt="Friend Request Icon"
              className="popup-icon"
              style={{width:'100px', height:'100%'}}
            />
          </div>
          <h4 className="popup-title">Connection Request</h4>
        </div>
        <div className="popup-body">
          <p>You have a connection request from</p>
          <h3 id="spnInmateFullaName" className="popup-name mb-3">
            {inmateKioskInvite?.InmateFullName || 'Unknown'}
          </h3>
          <p className="popup-message">
            If you already have an account, click on the Login button. If you are new to the application, click on the Sign Up button.
          </p>
        </div>
        <div className="popup-footer">
          <button onClick={onSignupClick} className="popup-btn liner-button">
            Sign Up
          </button>
          <button onClick={onLoginClick} className="popup-btn solid-button">
            Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupComponent;
